export const GiftButton = ({
  children,
  onClick
}) => {

  return (
    <p
      className="text-always-white mt-1 text-sm px-4 flex justify-center"
      style={{
        textShadow: "0 2px 5px rgba(0, 0, 0, 0.5)"
      }}
    >
        <span
          className="flex group cursor-pointer"
          onClick={onClick}
        >
          <svg
            className="h-5 w-5 mr-2 group-hover:text-red-300 transition duration-200 ease-in-out"
            fill="currentColor"
            viewBox="0 0 20 20"
            style={{
              filter:
                "drop-shadow(0 2px 5px rgba(0, 0, 0, 0.5))"
            }}
          >
            <path
              d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
              clipRule="evenodd"
              fillRule="evenodd"
            ></path>
          </svg>
          {children}
          <svg
            className="h-4 w-4 -ml-4 group-hover:ml-2 self-center transform scale-0 group-hover:scale-100 origin-left transition-all duration-200 ease-in-out"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clipRule="evenodd"
              fillRule="evenodd"
            ></path>
          </svg>
        </span>
    </p>
  )
}